import { BiErrorAlt } from "react-icons/bi";

const OrderError = () => {
  return (
    <div className="">
      <BiErrorAlt
        style={{
          fontSize: "150px",
          color: "red",
          marginBottom: "1%",
        }}
      />
      <h2>Vaša narudžba nije kreirana. Pokušajte ponovo!</h2>
    </div>
  );
};
export default OrderError;
